export default {
  paper: {
    borderRadius: '2px',
    boxShadow: '5px 5px 10px rgba(0, 0, 0, 0.15)',
  },
};
